/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useEffect, useState } from 'react';
import { ILastViewedViewProps } from './last-viewed';

export interface ILastViewed {
    productName: string;
    prodImage: string;
    prodURL: string;
}

export default (props: ILastViewedViewProps) => {
    const lastRecord: ILastViewed[] = [];

    const [lastRecordDetails, setLastRecordDetails] = useState(lastRecord);

    useEffect(() => {
        const product: any = localStorage.getItem('productInfo');
        const finalLastRecord = JSON.parse(product);

        if (finalLastRecord && finalLastRecord.length) {
            for (let i = 0; i < finalLastRecord.length; i++) {
                const prodDetails: ILastViewed = {
                    productName: '',
                    prodImage: '',
                    prodURL: ''
                };
                prodDetails.productName = finalLastRecord[i]['productName'];
                prodDetails.prodImage = finalLastRecord[i]['prodImage'];
                prodDetails.prodURL = finalLastRecord[i]['prodURL'];
                lastRecord.push(prodDetails);
            }
            setLastRecordDetails([...lastRecord]);
        }
    }, []);

    return (
        <>
            {lastRecordDetails.length > 0 && (
                <div className='row'>
                    <div className='last-viewed'>
                        <h3>RECENTLY VIEWED PRODUCTS</h3>
                        <div className='image-container-last-viewed'>
                            <ul>
                                {lastRecordDetails.map((item, key) => (
                                    <li key={key}>
                                        <a href={item.prodURL}>
                                            <img src={item.prodImage}></img>
                                            <span>{item.productName}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
